import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/reusable/Header/Header.js';
import FooterSection from './components/reusable/HomePageSections/FooterSection/FooterSection.js';
import getRoutes from './routes/Routes.js';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <a className="skip-link" href="#main">Skip to main content</a>
        <Header />
        <main id="main">
          <Routes>
            {getRoutes().map((route) => (
              <Route key={route.path} {...route} />
            ))}
          </Routes>
        </main>
        <FooterSection />
      </div>
    </BrowserRouter>
  );
}

export default App;
